import * as angular from 'angular';
import {LineEquipmentNameItemDisplay} from "./lineEquipmentNames.controller";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LineConfigsServiceName, {LineConfigsService} from "../../services/lineConfigs/lineConfigs.service";
import * as _ from "lodash";
import template from './editLineEquipmentName.tpl.html';

let requires = [UIUtilityServiceName, LoaderServiceName, NotifyServiceName, LineConfigsServiceName];

interface EditLineEquipmentNameController {
  save(): void;
  close(): void;
  dialogHeaderText: string;
  form: angular.IFormController;
  isNew: boolean;
  editedLineEquipmentName: LineEquipmentNameItemDisplay;
}

export interface EditLineEquipmentNameData {
  lineEquipmentName: LineEquipmentNameItemDisplay;
  locations: EnumOption[];
  types: EnumOption[];
}

export function openEditLineEquipmentName(data: EditLineEquipmentNameData,
                                          $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'EditLineEquipmentNameCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

class EditLineEquipmentNameCtrl implements EditLineEquipmentNameController {

  private loaderService: LoaderService;
  private notifyService: NotifyService;
  private $modalInstance: mm.foundation.modalInstance;
  private lineConfigsService: LineConfigsService;
  private uiUtilityService: UIUtilityService;
  editedLineEquipmentName: LineEquipmentNameItemDisplay;
  dialogHeaderText: string;
  form: angular.IFormController;
  isNew: boolean;
  locations: EnumOption[];
  types: EnumOption[];

  constructor(data: EditLineEquipmentNameData,
              loaderService: LoaderService,
              notifyService: NotifyService,
              uiUtilityService: UIUtilityService,
              $modalInstance: mm.foundation.modalInstance,
              lineConfigsService: LineConfigsService) {
    this.loaderService = loaderService;
    this.notifyService = notifyService;
    this.uiUtilityService = uiUtilityService;
    this.$modalInstance = $modalInstance;
    this.lineConfigsService = lineConfigsService;
    this.isNew = !data.lineEquipmentName.type;
    this.dialogHeaderText = `${(this.isNew ? 'Add' : 'Edit')} Line Equipment Type`;
    this.editedLineEquipmentName = data.lineEquipmentName;

    this.locations = data.locations;
    this.types = [];
    let eligibleTypes = ['inspect reject', 'counter'];
    data.types.forEach(type => {
      let canPush = !this.isNew || _.find(eligibleTypes, et => et === type.text.toLowerCase());
      if (canPush) {
        this.types.push(type);
      }
    });
  }

  setLocationAndTypeNames(item: LineEquipmentNameItemDisplay): void {
    item.locationName = _.find(this.locations, { value: item.location }).text;
    if (this.isNew) {
      item.typeName = _.find(this.types, { value: item.type }).text;
    }
  }

  save(): void {
    if (this.form.$invalid) {
      return;
    }

    this.setLocationAndTypeNames(this.editedLineEquipmentName);

    let command = {
      id: this.editedLineEquipmentName.id,
      location: this.editedLineEquipmentName.location,
      name: this.editedLineEquipmentName.name,
      type: this.editedLineEquipmentName.type
    };

    let promise = this.isNew
      ? this.lineConfigsService.addLineEquipmentName(command)
      : this.lineConfigsService.updateLineEquipmentName(command);

    this.loaderService.loadingPromise(promise.then(() => {
      this.$modalInstance.close(this.editedLineEquipmentName);
    }, this.notifyService.handleApiErrors));
  }

  close(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.editLineEquipmentName', requires)
  .controller('EditLineEquipmentNameCtrl', EditLineEquipmentNameCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/lineConfigs/editLineEquipmentName.controller.ts